import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const ClientsPage = () => {
  const clients = [
    { name: 'Saregama Ltd.', industry: 'Music', logo: null },
    { name: 'CS Jewels', industry: 'Jewellery', logo: null },
    { name: 'Jain Farm Fresh Foods', industry: 'FMCG', logo: null },
    { name: 'Mangal Graha Mandir Sansthan', industry: 'NGO', logo: null },
    { name: 'Indosource Technologies', industry: 'Engineering & IoT', logo: null },
    { name: 'Hello Media Group', industry: 'Media', logo: null },
    { name: 'Indian Red Cross Society, Jalgaon', industry: 'NGO', logo: null },
    { name: 'Nobel Foundation', industry: 'Education', logo: null },
  ];

  const testimonials = [
    {
      quote: 'Appdroid AI brought our events to life in ways we had\'t imagined. From promotional videos that captured the energy of our campaigns to uniquely crafted characters, their work elevated our brand storytelling to a completely new level.',
      author: 'Creative Director',
      company: 'Saregama',
      rating: 5,
    },
    {
      quote: 'The jewellery shoots were breathtaking — every piece looked like it was photographed in a world-class studio. Their AI model shoots and offer videos have consistently driven engagement and footfall for us. Truly exceptional work.',
      author: 'Marketing Head',
      company: 'CS Jewels',
      rating: 5,
    },
    {
      quote: 'They built us a clean, professional website that perfectly represents our brand. The team understood our vision quickly and delivered a digital presence we\'re genuinely proud of.',
      author: 'Marketing Head',
      company: 'Jain Farm Fresh Foods',
      rating: 5,
    },
    {
      quote: 'Appdroid AI has been creating our monthly devotional content with great reverence and creativity. The visuals are spiritually moving and our devotees connect with them deeply. We are very satisfied with their dedication.',
      author: 'Founding President',
      company: 'Mangal Graha Mandir Sansthan',
      rating: 5,
    },
  ];

  return (
    <div data-testid="clients-page" className="min-h-screen">
      {/* Hero with Video Background */}
      <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
            style={{ filter: 'brightness(0.6)' }}
          >
            <source
              src="https://download.samplelib.com/mp4/sample-15s.mp4"
              type="video/mp4"
            />
          </video>
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
          <div
            className="absolute inset-0 opacity-30"
            style={{
              background:
                'radial-gradient(circle at 50% 50%, rgba(124, 58, 237, 0.2) 0%, rgba(10, 10, 10, 0) 70%)',
            }}
          />
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter leading-none uppercase mb-6 text-white drop-shadow-2xl">
              Brands That
              <br />
              <span className="text-purple-400">Trust Us</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/80 max-w-2xl drop-shadow-lg">
              From startups to Fortune 500s. We deliver excellence.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Clients Grid */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {clients.map((client, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ scale: 1.05, y: -5 }}
                data-testid={`client-card-${index}`}
                className="bg-card border border-themed rounded-2xl p-8 hover:border-purple-500/50 transition-all duration-500 group relative overflow-hidden min-h-[200px] flex flex-col justify-center items-center text-center"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/0 to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative z-10">
                  <h3 className="text-xl font-bold mb-2">{client.name}</h3>
                  <p className="text-sm text-purple-500 font-medium">{client.industry}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      {/* <section className="py-24 md:py-32 bg-card">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-6xl font-extrabold text-primary tracking-tight leading-tight mb-4">
              What They Say
            </h2>
            <p className="text-lg text-muted">Real feedback from real clients.</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-card border border-themed rounded-2xl p-8"
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={20} className="fill-purple-500 text-purple-500" />
                  ))}
                </div>
                <p className="text-muted mb-6 leading-relaxed italic">"{testimonial.quote}"</p>
                <div>
                  <p className="font-bold text-primary">{testimonial.author}</p>
                  <p className="text-sm text-purple-500">{testimonial.company}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-extrabold text-primary tracking-tight leading-tight mb-8">
              Ready to join them?
            </h2>
            <a
              href="/contact"
              data-testid="clients-contact-btn"
              className="bg-purple-600 hover:bg-purple-700 text-white px-10 py-5 rounded-full font-bold text-lg tracking-wide transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(124,58,237,0.6)] inline-block"
            >
              Let's Talk
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ClientsPage;